import { Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'wre-detail-sidebar',
    templateUrl: './detail-sidebar.component.html',
    styleUrls: ['./detail-sidebar.component.sass'],
    standalone: false
})
export class DetailSidebarComponent implements OnInit {

    fieldId: string;
    isOpen = false;

    constructor(private router: Router, private activatedRoute: ActivatedRoute) { }
  
    ngOnInit() {
      this.activatedRoute.paramMap.subscribe(params => {
        this.isOpen = true;
        this.fieldId = params.get('id');
      });
    }
  
    closeSidebar() {
      this.isOpen = false;
      this.router.navigate([`admin/safr/field-management`]);
    }  
  }
  